
const digest = '5a6d2ce733af7d23b1d842caa70b2f79fbceaf46061e2d6b0956efb959caf9ef';
const classes = {"wrapper":"_wrapper_lrc8w_1","content":"_content_lrc8w_9"};
const css = `._wrapper_lrc8w_1 {
  font-family: "Rubik", sans-serif;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ffffff;
  overflow-y: hidden;
}
._wrapper_lrc8w_1 ._content_lrc8w_9 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  border: 1px solid #eaedf3;
  border-top: 0;
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}
._wrapper_lrc8w_1 ._content_lrc8w_9::-webkit-scrollbar {
  display: block;
}
._wrapper_lrc8w_1 ._content_lrc8w_9::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_lrc8w_1 ._content_lrc8w_9::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_lrc8w_1 ._content_lrc8w_9::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_lrc8w_1 ._content_lrc8w_9::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  